type TagsObject = { [key: string]: string };

export const tagsObject: TagsObject = {
	auth: "Authentication",
	finance: "Finance",
	communication: "Communication",
	mobile: "Mobile",
	protocol: "Protocol",
	social: "Social",
	identity: "Identity",
	document: "Document",
	url: "URL"
};